import { useState } from "react";
import api, { formatApiError } from "@/api";
import { Btn, Field, Input } from "@/components/ui-kit";
import { X } from "@phosphor-icons/react";
import { toast } from "sonner";

export function ChangePasswordModal({ open, onClose }) {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 4) return toast.error("New password must be at least 4 characters");
    if (next !== confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password changed");
      setCur(""); setNext(""); setConfirm("");
      onClose();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4" data-testid="change-password-modal">
      <form onSubmit={submit} className="card-flat w-full max-w-sm p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="heading text-xl font-bold">Change password</h3>
          <button type="button" onClick={onClose} data-testid="cp-close" className="text-[var(--text-3)] hover:text-[var(--text-1)]"><X size={20} /></button>
        </div>
        <div className="space-y-4">
          <Field label="Current password *"><Input data-testid="cp-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required /></Field>
          <Field label="New password *"><Input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} required /></Field>
          <Field label="Confirm new password *"><Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></Field>
        </div>
        <div className="flex gap-2 mt-6">
          <Btn type="submit" data-testid="cp-submit" disabled={busy}>{busy ? "Saving…" : "Update password"}</Btn>
          <Btn variant="ghost" type="button" onClick={onClose}>Cancel</Btn>
        </div>
      </form>
    </div>
  );
}
